<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr-other" style="padding-right: 5px"></i>
        巡查记录详情
      </div>
    </div>

    <!-- <unitList @select="getUnit" @getFirst='getOne'></unitList> -->

    <el-form ref="form" v-model="form" label-width="80px" :rules="rules" class="mt20">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-row> </el-row>
          <el-row>
            <el-form-item label-width="160px" prop="" label="巡查点编号">
              <el-input v-model="form.c_point_number"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label-width="160px" prop="" label="巡查点名称">
              <el-input v-model="form.c_point_name"></el-input>
            </el-form-item>
            <el-form-item label-width="160px" prop="" label="巡查点位置">
              <el-input v-model="form.c_point_number"></el-input>
            </el-form-item>
            <el-form-item label-width="160px" prop="" label="是否异常">
              <el-radio v-model="form.c_point_error" :label="1">异常</el-radio>
              <el-radio v-model="form.c_point_error" :label="0">正常</el-radio>
              <el-radio v-model="form.c_point_error" :label="2">当场整改</el-radio>
            </el-form-item>
            <el-form-item label-width="160px" prop="" label="巡查结果描述">
              <el-input type="textarea" v-model="form.c_point_error_desc"></el-input>
            </el-form-item>
            <el-form-item label-width="160px" prop="" label="整改结果描述">
              <el-input type="textarea" v-model="form.c_corrective_measures"></el-input>
            </el-form-item>
          </el-row>
        </el-col>
        <el-col :span="12">
          <el-row>
            <el-form-item label-width="160px" prop="" label="巡查点设备">
              <el-input v-model="form.c_point_basic"></el-input>
            </el-form-item>
            <el-form-item label-width="160px" prop="" label="NFC编号">
              <el-input v-model="form.c_nfc"></el-input>
            </el-form-item>
            <el-form-item label-width="160px" prop="" label="上报人员">
              <el-input v-model="form.c_commit_name"></el-input>
            </el-form-item>
            <el-form-item label-width="160px" prop="" label="创建时间">
              <el-input v-model="form.c_commit_time"></el-input>
            </el-form-item>
            <el-form-item v-if="$route.query.view" label-width="160px" prop="" label="状态">
              <el-button type="info" size="mini">{{ $map.checkstates[form.c_point_states] }}</el-button>
            </el-form-item>
            <el-form-item label-width="160px" prop="" label="整改时间">
              <el-input v-model="form.c_correction_time"></el-input>
            </el-form-item>
          </el-row>
        </el-col>
      </el-row>

      <!-- <el-row>
        <el-form-item
          label-width="160px"
          prop=""
          label="现场照片"
          v-for="item in form.imgList"
          :key="item"
        >
          <img class="ml20 mt20" :src="item" alt="" style="" /> </el-form-item
      ></el-row> -->
      <el-row>
        <el-col :span="12">
          <el-form-item label-width="160px" prop="" label="现场照片" v-if="form.imgList && form.imgList.length">
            <img class="ml20 mt20" v-for="item in form.imgList" :key="item" :src="item" alt="" style="max-height:390px" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label-width="160px" prop="" label="整改后照片" v-if="form.imgbackList && form.imgbackList.length">
            <img class="ml20 mt20" v-for="item in form.imgbackList" :key="item" :src="item" alt="" style="max-height:390px" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="btn-box flex1 center" style="margin-bottom: 40px">
      <el-button type="danger" @click="changestatus()" v-if="!$route.query.view">通过</el-button>
      <el-button type="primary" @click="changestatus(1)" v-if="!$route.query.view">复核</el-button>
      <el-button type="primary" @click="$router.back()">返回</el-button>
    </div>
  </div>
</template>

<script>
// import {buildList} from './options'
// import {addCompany, editCompany} from "../../api/company";
// import {getArea} from "../../api/common";
import { getSafeList } from "../../api/safety";

export default {
  data() {
    return {
      id: this.$route.query.id || "",
      form: {},
      rules: {},
      radio: "",
      CheckedKeys: [],
      props: {
        label: "111",
        children: "zo11nes",
      },
      list2: [],

      list: [],
    };
  },
  created() {
    if (this.id) {
      this.$post(`/record/recorddetail/${this.id}`).then((res) => {
        this.form = res.data[0];

        if (this.form.c_log_image_url) {
          //整改前
          this.form.imgList = this.form.c_log_image_url.split(";");
        }
        if (this.form.c_log_image_url_out) {
          //整改后
          this.form.imgbackList = this.form.c_log_image_url_out.split(";");
        }
      });
    }
    this.getList();
  },
  mounted() {},

  methods: {
    handleCheckChange(v, b) {
      // console.log(v.id);
      // console.log(v)
      this.CheckedKeys = this.$refs.tree1.getCheckedKeys();
      this.$refs.tree1.getCheckedKeys();
    },
    addtime() {
      if (this.form.get_rate.length < 2) {
        this.form.get_rate.push({
          m_start_time: "",
          m_end_time: "",
          m_rate: "",
        });
      } else {
        this.form.get_rate.splice(1);
      }
    },
    getList() {
      this.loading = true;
    },
    //通过不通过

    changestatus(stae) {
      var c_point_states = stae ? 3 : 4;

      this.$post("/record/recordif", {
        c_log_id: this.form.c_log_id,
        c_point_states,
      }).then((res) => {
        // this.$message.success("操作成功");
        this.$message({
                message: '操作成功',
                type: 'success',
                duration: 700,
              });
        
      });
    },
  },
};
</script>

<style scoped>
.container-list {
  padding: 0 20px;
}
.tree {
  font-size: 18px;
}
</style>
